import { makeChartComp } from '../../util/makeChartComp';
var GaugeChart = makeChartComp('Gauge');
export default GaugeChart;
